import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createUploadLink } from "apollo-upload-client";
import axios from 'axios'; // To get CSRF token
import Cookies from 'js-cookie'; // To read cookies easily
import Pusher from "pusher-js";
import PusherLink from "./PusherLink";
import { API_URL } from "../Utils/utils";

// Function to fetch CSRF token before making requests
const getCsrfToken = async () => {
  try {
    // Load the CSRF token, which Laravel will store in cookies
    await axios.get(`${API_URL}/sanctum/csrf-cookie`, {
      withCredentials: true, // Ensures the CSRF token is stored in cookies
    });
  } catch (error) {
    console.error('Failed to load CSRF token:', error);
  }
};

// Create the upload link for handling GraphQL uploads with credentials
const uploadLink = createUploadLink({
  uri: API_URL + "/graphql",
  credentials: 'include', // Passes the cookies for session-based authentication
});

// Set up the authLink, responsible for ensuring the CSRF token is loaded before requests
const authLink = setContext(async (_, { headers }) => {
  // Fetch CSRF token before any authenticated requests
  await getCsrfToken();

  // Read the XSRF-TOKEN from cookies
  const xsrfToken = Cookies.get('XSRF-TOKEN');

  // Return headers, including the CSRF token in the X-XSRF-TOKEN header
  return {
    headers: {
      ...headers,
      'X-XSRF-TOKEN': xsrfToken ? decodeURIComponent(xsrfToken) : '',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', // Add this line for the X-Requested-With header
    },
  };
});

// Set up the Pusher link (without bearer tokens since CSRF token is used)
const pusherLink = new PusherLink({
  pusher: new Pusher(process.env.REACT_APP_PUSHER_API_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    authEndpoint: `${process.env.REACT_APP_BACKEND_URL}/graphql/subscriptions/auth`,
    auth: {
      headers: {}, // No need for Bearer tokens, we use CSRF cookies for session-based auth
    },
  }),
});

// Combine the links: authLink -> pusherLink -> uploadLink
const link = ApolloLink.from([authLink, pusherLink, uploadLink]);

// Create the Apollo Client instance
const graphqlClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
});

export default graphqlClient;
